<template>
  <nuxt />
</template>

<script>
export default {
  middleware: ['initializer', 'guestInvite']
}
</script>
